module.exports = __webpack_public_path__ + "img/list TimeAttendance active.c7812596.svg";